const ErrorMessage = {
  APPLICANT_INTERRUPTED_INTERVIEW: 'Applicant interrupted the video interview',
  ADDITIONAL_DOCUMENT_REQUIRED: 'Additional document required',
  BACK_SIDE_MISSING: 'Back side of the document is missing',
  BAD_AVATAR: 'Avatar does not meet requirements',
  BAD_FACE_MATCHING: 'Face matching failed between document and selfie',
  BAD_PROOF_OF_ADDRESS: 'Incorrect proof of address',
  BAD_PROOF_OF_IDENTITY: 'Incorrect proof of identity',
  BAD_PROOF_OF_PAYMENT: 'Incorrect proof of payment',
  BAD_SELFIE: 'Bad selfie uploaded',
  BAD_VIDEO_SELFIE: 'Bad video selfie uploaded',
  BLACK_AND_WHITE: 'Black and white document not accepted',
  COMPANY_NOT_DEFINED_BENEFICIARIES: 'Beneficiaries not defined',
  COMPANY_NOT_DEFINED_REPRESENTATIVES: 'Company representatives not defined',
  COMPANY_NOT_DEFINED_STRUCTURE: 'Company control structure undefined',
  COMPANY_NOT_VALIDATED_BENEFICIARIES: 'Beneficiaries not validated',
  COMPANY_NOT_VALIDATED_REPRESENTATIVES: 'Representatives not validated',
  CONNECTION_INTERRUPTED: 'Video interview connection interrupted',
  DIGITAL_DOCUMENT: 'Digital document is not accepted',
  DOCUMENT_DEPRIVED: 'Applicant deprived of document',
  DOCUMENT_DAMAGED: 'Document is damaged',
  DOCUMENT_MISSING: 'Required document missing during video call',
  DOCUMENT_PAGE_MISSING: 'Document page is missing',
  EXPIRATION_DATE: 'Document is expired',
  FRONT_SIDE_MISSING: 'Front side of the document is missing',
  GRAPHIC_EDITOR: 'Document appears to be edited',
  ID_INVALID: 'Invalid identity document',
  INCOMPATIBLE_LANGUAGE: 'Incompatible document language',
  INCOMPLETE_DOCUMENT: 'Incomplete document',
  INCORRECT_SOCIAL_NUMBER: 'Incorrect social number',
  PROBLEMATIC_APPLICANT_DATA: 'Applicant data inconsistent with document',
  REQUESTED_DATA_MISMATCH: 'Submitted data mismatch with document',
  SELFIE_WITH_PAPER: 'Missing required selfie with paper',
  LOW_QUALITY: 'Low quality document image',
  NOT_ALL_CHECKS_COMPLETED: 'Not all verification checks completed',
  SCREENSHOTS: 'Screenshots are not accepted',
  UNFILLED_ID: 'ID is unsigned or unsealed',
  UNSATISFACTORY_PHOTOS: 'Unsatisfactory photos',
  UNSUITABLE_ENV: 'Unsuitable environment for verification',
  WRONG_ADDRESS: 'Address mismatch',
  ADVERSE_MEDIA: 'Adverse media found',
  AGE_REQUIREMENT_MISMATCH: 'Age requirement not met',
  BLOCKLIST: 'Applicant is on blocklist',
  CHECK_UNAVAILABLE: 'Verification check unavailable',
  COMPROMISED_PERSONS: 'Applicant flagged as politically compromised',
  CRIMINAL: 'Applicant has criminal record',
  DB_DATA_MISMATCH: 'Database data mismatch',
  DB_DATA_NOT_FOUND: 'Database data not found',
  DOCUMENT_TEMPLATE: 'Document appears to be a template',
  DUPLICATE: 'Duplicate applicant not allowed',
  EXPERIENCE_REQUIREMENT_MISMATCH: 'Experience requirement not met',
  FORGERY: 'Forgery attempt detected',
  FRAUDULENT_LIVENESS: 'Liveness check bypass attempt',
  FRAUDULENT_PATTERNS: 'Fraudulent patterns detected',
  INCONSISTENT_PROFILE: 'Inconsistent applicant profile',
  PEP: 'Applicant is a PEP',
  REGULATIONS_VIOLATIONS: 'Regulations violation detected',
  SANCTIONS: 'Applicant is on sanctions list',
  SELFIE_MISMATCH: 'Selfie does not match document',
  SPAM: 'Applicant flagged as spam',
  NOT_DOCUMENT: 'Uploaded file is not a valid document',
  THIRD_PARTY_INVOLVED: 'Third-party involvement detected',
  UNSUPPORTED_LANGUAGE: 'Unsupported language for video verification',
  WRONG_USER_REGION: 'User region not allowed',
  SUSPICIOUS_PATTERNS: 'Suspicious patterns detected'
} as const

export const getSumSubErrorMessage = (errorCode: string): string => {
  return 'KYC Failed: ' + (ErrorMessage[errorCode as keyof typeof ErrorMessage] || 'Unknown error')
}
